import type { Messages } from '../catalogue.en'

export const anamnesis: Partial<Messages> = {
  'anamnesis.title': 'אנמנזה',
  'anamnesis.description': 'היסטוריית חיים ואלרגיות, משותפות לכל התיק ונשמרות בגרסאות.',
  'anamnesis.loading': 'טוען אנמנזה…',
  'anamnesis.loadFailed': 'לא ניתן לטעון את האנמנזה.',
  'anamnesis.forbidden': 'התפקיד שלך אינו מאפשר לצפות באנמנזה.',
  'anamnesis.notFound': 'המטופל לא נמצא.',
  'anamnesis.empty': 'טרם נרשמה אנמנזה',
  'anamnesis.emptyDetail': 'רשמו את היסטוריית החיים והאלרגיות פעם אחת; כל ביקור יקרא אותן.',
  'anamnesis.edit': 'עריכה',
  'anamnesis.protocolEdit': 'שינוי בתיק המטופל',
  'anamnesis.protocolSealedNone': 'לא נשמרה אנמנזה עם הפרוטוקול החתום.',
  'anamnesis.record': 'רישום אנמנזה',
  'anamnesis.save': 'שמירה',
  'anamnesis.saving': 'שומר…',
  'anamnesis.cancel': 'ביטול',
  'anamnesis.saved': 'נשמר כגרסה {revision}.',
  'anamnesis.historyShow': 'היסטוריית גרסאות',
  'anamnesis.historyHide': 'הסתרת ההיסטוריה',
  'anamnesis.historyTitle': 'היסטוריית גרסאות',
  'anamnesis.historyEmpty': 'אין עדיין גרסאות.',
  'anamnesis.historyFailed': 'לא ניתן לטעון את היסטוריית הגרסאות.',
  'anamnesis.historyMore': 'הצגת גרסאות קודמות',
  'anamnesis.version': 'גרסה {revision}',
  'anamnesis.recordedAt': 'נרשם {when}',
  'anamnesis.recordedBy': 'נרשם {when} על ידי {who}',
  'anamnesis.allergiesTitle': 'אלרגיות ואי-סבילות',
  'anamnesis.allergyStatus': 'מצב אלרגיות',
  'anamnesis.lifeHistoryTitle': 'היסטוריית חיים',
  'anamnesis.lifeHistoryEmpty': 'לא נרשמה היסטוריית חיים.',
  'anamnesis.entryKind': '{type} — {category}',
  'anamnesis.manifestations': 'תגובות',
  'anamnesis.listSeparator': ', ',
  'anamnesis.note': 'הערה',
  'anamnesis.entryLegend': 'אלרגיה {number}',
  'anamnesis.entryType': 'סוג',
  'anamnesis.entryCategory': 'קטגוריה',
  'anamnesis.criticalityLabel': 'סיכון',
  'anamnesis.criticalityNone': 'לא צוין',
  'anamnesis.substance': 'חומר',
  'anamnesis.substanceBrowse': 'בחירה מהמילון',
  'anamnesis.dictionaryTitleDrug': 'חומרים תרופתיים',
  'anamnesis.dictionaryTitleOther': 'אלרגנים אחרים',
  'anamnesis.dictionaryTabCatalogue': 'מילון',
  'anamnesis.dictionarySearchPlaceholder': 'שם החומר',
  'anamnesis.dictionaryHintClassified': 'פתחו קבוצת ATC או הקלידו לפחות שתי אותיות מהשם הגנרי הבינלאומי. שמות מסחריים אינם במילון.',
  'anamnesis.dictionaryHint': 'הקלידו לפחות שתי אותיות מהשם או בחרו מהרשימה.',
  'anamnesis.dictionaryUnclassified': 'ללא קבוצת ATC',
  'anamnesis.dictionaryOtherLetters': 'תווים אחרים',
  'anamnesis.dictionaryMore': 'הצגת עוד',
  'anamnesis.dictionaryLoading': 'טוען את המילון…',
  'anamnesis.dictionarySearching': 'מחפש…',
  'anamnesis.dictionaryLoadFailed': 'לא ניתן היה לטעון את המילון.',
  'anamnesis.dictionarySearchFailed': 'לא ניתן היה לחפש במילון.',
  'anamnesis.dictionarySearchEmpty': 'לא נמצאה התאמה במילון.',
  'anamnesis.dictionaryEmptyLevel': 'הקבוצה ריקה.',
  'anamnesis.dictionarySearchResults': 'תוצאות החיפוש',
  'anamnesis.clearCoding': 'הסרת קוד המילון',
  'anamnesis.reactionText': 'תגובה במילים שלך',
  'anamnesis.addReaction': 'הוספת תגובה',
  'anamnesis.reactionSearch': 'חיפוש תגובה במילון',
  'anamnesis.removeReaction': 'הסרת התגובה {name}',
  'anamnesis.removeEntry': 'הסרת אלרגיה {number}',
  'anamnesis.addEntry': 'הוספת אלרגיה',
  'anamnesis.habitSearch': 'חיפוש הרגל במילון',
  'anamnesis.removeCode': 'הסרת {name}',
  'anamnesis.problemNoEntries': 'יש לציין לפחות אלרגיה אחת או לבחור מצב אחר.',
  'anamnesis.problemNoSubstance': 'לכל אלרגיה יש לציין חומר.',
  'anamnesis.changedConcurrently': 'האנמנזה השתנתה בזמן העריכה.',
  'anamnesis.codingInvalid': 'קוד מילון לא התקבל. בחרו אותו מהרשימה שוב.',
  'anamnesis.codingUnbound': 'למרפאה אין מילון מוגדר לשדה זה. הסירו את הקוד והשאירו את הטקסט.',
  'anamnesis.writeSessionEnded': 'ההתחברות הסתיימה. התחברו שוב כדי לשמור.',
  'anamnesis.writeForbidden': 'התפקיד שלך אינו מאפשר לשנות את האנמנזה.',
  'anamnesis.writeInvalid': 'האנמנזה לא התקבלה. בדקו את השדות ונסו שוב.',
  'anamnesis.writeUnavailable': 'השרת אינו זמין. השינויים נשמרו בטופס; נסו שוב.',
  'anamnesis.writeFailed': 'לא ניתן לשמור את האנמנזה. נסו שוב.',
  'anamnesis.conflictTitle': 'בזמן העריכה נשמרה גרסה {revision}.',
  'anamnesis.conflictDetail': 'השינויים שלך עדיין כאן. שמרו אותם מעל הגרסה החדשה, או בטלו אותם וקראו את מה שנשמר.',
  'anamnesis.conflictOverwrite': 'שמירת הגרסה שלי במקומה',
  'anamnesis.conflictDiscard': 'ביטול השינויים שלי',
  'anamnesis.markTitle': 'אלרגיות:',
  'anamnesis.markOpen': 'פתיחת האנמנזה',
  'anamnesis.markMore': 'ועוד {count}',
  'anamnesis.section.pastIllnesses': 'מחלות בעבר',
  'anamnesis.section.surgeriesInjuries': 'ניתוחים ופציעות',
  'anamnesis.section.familyHistory': 'היסטוריה משפחתית',
  'anamnesis.section.livingConditions': 'תנאי חיים ועבודה',
  'anamnesis.section.habits': 'הרגלים',
  'anamnesis.section.obstetricGynecological': 'היסטוריה מיילדותית וגינקולוגית',
  'anamnesis.section.transfusions': 'עירויי דם',
  'anamnesis.section.medications': 'תרופות קבועות',
  'anamnesis.section.other': 'אחר',
  'anamnesis.status.recorded': 'יש אלרגיות או אי-סבילות',
  'anamnesis.status.noneKnown': 'אין אלרגיות ידועות',
  'anamnesis.status.unknown': 'לא נבדק',
  'anamnesis.type.allergy': 'אלרגיה',
  'anamnesis.type.intolerance': 'אי-סבילות',
  'anamnesis.category.medication': 'תרופה',
  'anamnesis.category.food': 'מזון',
  'anamnesis.category.insect': 'חרקים',
  'anamnesis.category.other': 'אחר',
  'anamnesis.criticality.low': 'סיכון נמוך',
  'anamnesis.criticality.high': 'סיכון גבוה',
  'anamnesis.criticality.unableToAssess': 'הסיכון לא הוערך',
}
